module.exports = __webpack_public_path__ + "static/img/culturePic4.a303356.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/culturePic4.jpg
// module id = uiNT
// module chunks = 0